module.exports = __webpack_public_path__ + "static/media/aramex-logo.0f5ea2fa.svg";